'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _throttleDebounce = require('throttle-debounce');

var _throttleDebounce2 = _interopRequireDefault(_throttleDebounce);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRouter = require('react-router');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LibraryNavBar = function (_React$Component) {
  (0, _inherits3.default)(LibraryNavBar, _React$Component);

  function LibraryNavBar() {
    (0, _classCallCheck3.default)(this, LibraryNavBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LibraryNavBar.__proto__ || (0, _getPrototypeOf2.default)(LibraryNavBar)).call(this));

    _this.handleWindowScroll = _this.handleWindowScroll.bind(_this);
    _this.checkIfSticky = _this.checkIfSticky.bind(_this);

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(LibraryNavBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('scroll', this.handleWindowScroll);

      setTimeout(function () {
        _this2.navBarTop = window.pageYOffset + _reactDom2.default.findDOMNode(_this2.refs.navBar).getBoundingClientRect().top;
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleWindowScroll);
    }
  }, {
    key: 'handleWindowScroll',
    value: function handleWindowScroll() {
      window.requestAnimationFrame(this.checkIfSticky);
    }
  }, {
    key: 'checkIfSticky',
    value: function checkIfSticky() {
      if (document.body.clientHeight == 0) return;

      var el = _reactDom2.default.findDOMNode(this.refs.navBar);
      var headerHeight = 84;
      var sticky = this.state.sticky;


      var shouldStick = window.pageYOffset + headerHeight > this.navBarTop;

      if (!sticky && shouldStick) {
        this.setState({ sticky: true });
      } else if (sticky && !shouldStick) {
        this.setState({ sticky: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var sticky = this.state.sticky;
      var _props = this.props,
          searchFocused = _props.searchFocused,
          loggedIn = _props.loggedIn;

      var currentType = this.props.currentType || 'everything';

      var styles = require('./LibraryNavBar.scss');

      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.LibraryNavBar, true), (0, _defineProperty3.default)(_classnames, styles['LibraryNavBar--sticky'], sticky), (0, _defineProperty3.default)(_classnames, styles['LibraryNavBar--hidden'], sticky && searchFocused), _classnames));

      return _react2.default.createElement(
        'div',
        { className: classes, ref: 'navBar' },
        _react2.default.createElement(
          'div',
          { className: styles.PageTabs },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/megascans/library/types/' + currentType, className: styles.PageTab, activeClassName: styles['PageTab--active'] },
            'Latest'
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/megascans/library/packs', className: styles.PageTab, activeClassName: styles['PageTab--active'] },
            'Packs'
          ),
          loggedIn && [_react2.default.createElement(
            _reactRouter.Link,
            { to: '/megascans/library/myscans', key: 'myscans', className: '' + styles.PageTab, activeClassName: styles['PageTab--active'] },
            'My Scans'
          ), _react2.default.createElement(
            _reactRouter.Link,
            { to: '/megascans/library/favorited', key: 'favorited', className: '' + styles.PageTab, activeClassName: styles['PageTab--active'] },
            'Favorites'
          )]
        )
      );
    }
  }]);
  return LibraryNavBar;
}(_react2.default.Component);

exports.default = LibraryNavBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LibraryNavBar/LibraryNavBar.jsx
// module id = 2357
// module chunks = 0